import axiosInstance from "../axiosInterceptor";

export async function getPostingStreak() {
  const response = await axiosInstance.get(`student/postingStreak`);
  const data = response?.data;
  return data;
}
